
import timeutils from 'utils/wt-time-utils'
export default{
  policyManage (data, name) {
    data.forEach(item => {
      item.type = name
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
    })
    return data
  },
  policyDetail (data) {
    data.created_date = data.createdDate && timeutils.format(data.createdDate)
    return data
  }
}
